module.exports = __webpack_public_path__ + "media/images/element/30-935c6a0bc4c10095e66bfa97c196207b.svg";